import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import { DashboardEditorProps } from "components/ComponentTypeTypes";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import React, { FC } from "react";
import { T } from "services/lang/LanguageService";
import { diffTypeOptions, LastValueIndicatorProps } from "../LastValueIndicatorTypes";

const LastValueIndicatorEditor: FC<DashboardEditorProps<LastValueIndicatorProps>> = ({
  config,
  onConfigChange,
}) => {
  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-column gap-2 w-12">
        <label htmlFor="valueDataset">{T("word.dataset")}</label>
        <DatasetDropdown
          value={config.valueDataset}
          onChange={val => onConfigChange({ ...config, valueDataset: val ?? undefined })}
        />
      </div>
      <div className="flex flex-row gap-3">
        <div className="flex flex-column gap-2">
          <label htmlFor="title">{T("word.title")}</label>
          <InputText
            id="title"
            value={config.title}
            onChange={e => onConfigChange({ ...config, title: e.target.value })}
            className="p-inputtext-sm"
            placeholder={T("action.write-title")}
          />
        </div>
        <div className="flex flex-column gap-2">
          <label htmlFor="subtitle">{T("word.subtitle")}</label>
          <InputText
            id="subtitle"
            value={config.subtitle}
            onChange={e => onConfigChange({ ...config, subtitle: e.target.value })}
            className="p-inputtext-sm"
            placeholder={T("action.write-subtitle")}
          />
        </div>
        <div className="w-2 gap-2 flex flex-column justify-content-between">
          <label htmlFor="updateFrequency">{T("load-conf.update-frequency")}</label>
          <div className="p-inputgroup w-full">
            <InputNumber
              id="updateFrequency"
              value={config.updateFrequency as number}
              onValueChange={e => onConfigChange({ ...config, updateFrequency: e.value ?? 0 })}
            />
            <span className="p-inputgroup-addon">s</span>
          </div>
        </div>
        <div className="flex flex-column gap-2 w-2">
          <label htmlFor="highlightValue">{T("action.highlight-value")}</label>
          <InputSwitch
            id="highlightValue"
            checked={config.highlightValue ?? false}
            onChange={e => onConfigChange({ ...config, highlightValue: e.value })}
          />
        </div>
      </div>
      <Divider />
      <div className="flex flex-row gap-3">
        <div className="flex flex-column gap-2 w-3">
          <label htmlFor="displayLastValueDiff">{T("action.display-last-value-difference")}</label>
          <InputSwitch
            id="hideValues"
            checked={config.displayLastValueDiff ?? false}
            onChange={e => onConfigChange({ ...config, displayLastValueDiff: e.value })}
          />
        </div>
        {config.displayLastValueDiff && (
          <>
            <div className="flex flex-column gap-2 w-3">
              <label htmlFor="useDiffIndicatorColors">
                {T("action.use-diff-indicator-colors")}
              </label>
              <InputSwitch
                id="useDiffIndicatorColors"
                checked={config.useDiffIndicatorColors ?? false}
                onChange={e => onConfigChange({ ...config, useDiffIndicatorColors: e.value })}
              />
            </div>
            <div className="flex flex-column gap-2 w-2">
              <label htmlFor="diffType">{T("word.diff-type")}</label>
              <Dropdown
                id="diffType"
                value={config.diffType}
                options={diffTypeOptions}
                onChange={e => onConfigChange({ ...config, diffType: e.value })}
                placeholder={T("word.select-one")}
                className="p-inputtext-sm"
              />
            </div>
            <div className="flex flex-column gap-2 w-3">
              <label htmlFor="diffValueDecimalPlaces">{T("word.diff-decimal-places")}</label>
              <InputNumber
                id="diffValueDecimalPlaces"
                value={config.diffValueDecimalPlaces as number}
                onValueChange={e =>
                  onConfigChange({ ...config, diffValueDecimalPlaces: e.value ?? 0 })
                }
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LastValueIndicatorEditor;
